var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 27,
    viewBox: "0 0 4 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.10889C4 1.00432 3.10457 0.108887 2 0.108887C0.89543 0.108887 0 1.00432 0 2.10889V24.1089C0 25.2135 0.89543 26.1089 2 26.1089C3.10457 26.1089 4 25.2135 4 24.1089V2.10889Z",
    fill: "url(#paint0_linear_29_5084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_5084",
    x1: 0.499902,
    y1: 0.108889,
    x2: 4.0001,
    y2: 25.6089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A27BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleFrame);
export default __webpack_public_path__ + "static/media/rectangleFrame.e863c83b87b8f731de3bd167402c4160.svg";
export { ForwardRef as ReactComponent };